const collection = {
    slug: "sacai-2027ss-menswear-origin-hybrid-function-guide",
    metaTitle:
      "sacai 2027SSとは｜メンズウェアの原点・機能とハイブリッドを徹底解説｜買取・レンタル",
    metaDescription:
      "sacai 2027SSメンズコレクションを徹底解説。阿部千登勢がメンズ単独ショーで問い直した「sacaiのメンズウェアとは何か」。ボンバー、トレンチ、ネイビーブレザー、消防服のクラスプ、巨大ポケット、解体されたネクタイ、Brooks Brothers、Soul II Soul、Birkenstockとの協業から、機能とハイブリッドの原点をEnclopedia独自の視点で読み解き、sacai買取・レンタルへ案内します。",
    metaKeywords:
      "sacai 2027SS,sacai 2027春夏,サカイ 2027SS,サカイ 2027春夏,sacai メンズ 2027SS,sacai メンズウェア,sacai ハイブリッド,sacai デザイン,sacai 阿部千登勢,sacai Brooks Brothers,sacai Soul II Soul,sacai Birkenstock,sacai ボンバージャケット,sacai トレンチコート,sacai ネイビーブレザー,sacai 買取,サカイ 買取,sacai 高価買取,サカイ 高価買取,sacai レンタル,サカイ レンタル,sacai アーカイブ,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/sacai-2027ss-menswear-origin-hybrid-function-guide",
    heroImage:
      "media/archive_fashion/archive33.png",
    heroImageAlt:
      "sacai 2027SSメンズコレクションの機能とハイブリッドを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "33 / AUTHENTIC MENSWEAR",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "sacai 2027SS｜メンズ単独ショーで問い直した、sacaiのメンズウェアとは何か",
    lead:
      "sacai 2027SS。\n\n今季、阿部千登勢が問い直したのは、新しい男性像ではありません。\n\nもっと基本的な問いです。\n\n“sacaiのメンズウェアとは何か”。\n\n普段のsacaiは、メンズとウィメンズの境界を越えながら、異なる服、素材、用途を接続します。\nしかし2027SSでは、ウィメンズをわずかなルックに抑えたメンズ中心のショーを選びました。\n\nそこで並んだのは、男性のワードローブを構成してきた基本的な服です。\n\nボンバージャケット。\nカーディガン。\nシャツ。\nトレンチコート。\nネイビーブレザー。\nスーツ。\nデニムジャケット。\nレザージャケット。\nネクタイ。\nワークウェア。\n\nただし、どれもそのままではありません。\n\n消防服に使われるような金属製クラスプが、黒いオーバーシャツから黄色いニット、ウォッシュ加工されたトレンチへ横断する。\n\nパンツには、身体から外側へ大きく張り出すポーチポケットが付く。\n\nBrooks Brothersのネイビーブレザーには、余分なレイヤー、余分なスリット、余分なラペル、余分な縫い目が加わる。\n\nネクタイは首を整える道具ではなくなり、長いボウ、肩を覆う布、房飾り、コサージュへ変わる。\n\nBirkenstockのArizona、Boston、Madridは、一足の中で別の型と接続される。\n\nここで行われているのは、sacaiらしい異素材切替の再提示ではありません。\n\n男性服を成立させてきた“機能”を一度取り外し、別の場所へ移すことです。\n\n留め具は閉じるためだけのものではない。\nポケットは収納するためだけのものではない。\nラペルはスーツの格式を示すためだけのものではない。\nネクタイは男性を社会へ適応させるためだけのものではない。\n\nEnclopediaでは、sacai 2027SSを、ブランドの得意技へ回帰したコレクションではなく、ハイブリッドという方法がなぜ必要なのかを、男性服の機能から問い直したコレクションとして読み解きます。",
    keywordLine: [
      "sacai 2027ss",
      "authentic menswear",
      "function and hybrid",
      "sacai buyback rental",
    ],
    thesis:
      "sacai 2027SSの原点回帰とは、過去の代表的な異素材切替を繰り返すことではありません。ボンバー、トレンチ、ブレザー、シャツ、ネクタイ、ポケット、留め具など、男性服を成立させてきた機能を分解し、別の用途と関係へ組み替えることで、“日常着を更新する”というsacai本来の思想を再確認したシーズンです。",
    whyTitle:
      "sacaiのメンズウェアにおける“原点”とは何か。",
    whyBody:
      "sacaiの原点は、異素材を一着へ組み合わせることだと説明されがちです。\n\nニットとシャツ。\nMA-1とコート。\nテーラリングとミリタリー。\nプリーツとワークウェア。\n\nしかし、ハイブリッドは完成した見た目であって、原点そのものではありません。\n\nsacaiのより根本的な出発点は、日常的な服を疑うことです。\n\nなぜシャツは、この形でなければならないのか。\nなぜジャケットの前後は、同じジャンルに属していなければならないのか。\nなぜポケットは収納のためだけに存在するのか。\nなぜネクタイは首から真下へ垂れなければならないのか。\nなぜフォーマルと機能服は分けられるのか。\n\n阿部千登勢は、服の記号を否定するのではなく、その服が当たり前になった理由を調べ、別の答えを加えます。\n\nだからsacaiの服には、元の服が残る。\n\nボンバーはボンバーだと分かる。\nトレンチはトレンチだと分かる。\nBrooks Brothersのブレザーは、正統なアメリカントラッドだと分かる。\nBirkenstockも、どのモデルが起点か分かる。\n\nその真正性を残したまま、別の構造を差し込む。\n\n壊して正体を消すのではなく、正体を残したまま可能性を増やす。\n\nこれがsacaiのメンズウェアにおける原点です。\n\n2027SSは、その方法を男性服の基本形だけに集中させることで、ハイブリッドを装飾ではなく“服を更新する思考”として見せました。",
    pillars: [
      {
        number: "01",
        title: "AUTHENTIC BEFORE HYBRID",
        text:
          "sacaiのハイブリッドは、異質な服を無作為に混ぜることではありません。まずボンバー、トレンチ、ブレザー、ネクタイなどの原型を尊重し、その真正性を残したまま別の機能を差し込みます。",
      },
      {
        number: "02",
        title: "FUNCTION REASSIGNED",
        text:
          "2027SSでは、留め具、ポケット、ラペル、ネクタイ、ストラップの用途が再配置されます。機能を消すのではなく、本来とは違う仕事を与えることがsacaiの新しさです。",
      },
      {
        number: "03",
        title: "DJ-LIKE HYBRIDIZATION",
        text:
          "Soul II Soulの楽曲がリミックスされたように、阿部千登勢は既存のワードローブをサンプリングし、異なる服のリズムを重ねます。ハイブリッドは接合ではなく編集です。",
      },
      {
        number: "04",
        title: "ARCHIVE BEFORE RELEASE",
        text:
          "2027SSはまだ販売前です。だからこそ、過去のMA-1、トレンチ、ブレザー、ニット、シャツ、コラボレーション作品を、sacaiの原点から再評価する入口になります。",
      },
    ],
    readingTitle:
      "ボンバー、トレンチ、Brooks Brothers、消防服のクラスプ、ネクタイ、Soul II Soul、Birkenstockから読むsacai 2027SS。",
    readingIntro:
      "2027SSは、sacaiが得意とするハイブリッドの見本市ではありません。メンズ中心の構成にすることで、阿部千登勢は男性服の基本要素を細かく検証しました。そこでは、服と服を接続する以前に、ポケット、留め具、ラペル、ネクタイ、ストラップが何のために存在するのかが問い直されています。sacaiの原点とは、異素材ではなく、当たり前の機能を別の可能性へ開くことです。",
    observations: [
      {
        index: "01",
        title:
          "メンズ単独に近いショーは、男性性を強調するためではない",
        text:
          "阿部千登勢は2027SSを、少数のウィメンズルックを含む“メンズ中心のショー”として構成しました。\n\nしかし、これは男性らしさへ回帰したという意味ではありません。\n\nスーツを着る男性。\nワークウェアを着る男性。\nネクタイを締める男性。\nボンバーやトレンチを着る男性。\n\nそうした既存の男性像を強めるのではなく、それを成立させている衣服を細部まで分解して見るためです。\n\nメンズだけへ焦点を絞ることで、男性服の規則が見えやすくなる。\n\n前開き。\nラペル。\n肩線。\nポケット。\nネクタイ。\n裾。\n留め具。\n\nその規則を消すのではなく、一つずつ別の働きへ変える。\n\n2027SSのメンズフォーカスは、男性性の宣言ではなく、男性服を研究するための焦点調整です。",
      },
      {
        index: "02",
        title:
          "sacaiの原点は、ハイブリッドという見た目ではなく“日常着への疑問”にある",
        text:
          "sacaiを象徴する言葉として、ハイブリッドがあります。\n\nしかしハイブリッドだけを見れば、異素材切替やドッキングを再現するブランドは少なくありません。\n\nsacaiが長く独自性を保てた理由は、組み合わせの珍しさではない。\n\n日常着に対して、非常に具体的な疑問を持ち続けてきたからです。\n\nこの服は、なぜこの順序で組み立てられているのか。\nこのパーツは、本当にこの場所に必要なのか。\n二つの服は、なぜ別々に着なければならないのか。\n\n2027SSで原点へ戻るとは、過去の人気商品へ戻ることではありません。\n\n服を当然のものとして受け入れず、もう一度、構造と用途を問い直すことです。",
      },
      {
        index: "03",
        title:
          "ハイブリッドとは、二着を半分ずつ混ぜることではない",
        text:
          "sacaiのハイブリッドは、“AとBを足す”という説明だけでは不十分です。\n\nMA-1とトレンチ。\nニットとシャツ。\nジャケットとブルゾン。\n\n確かに二つの服は存在します。\nしかし重要なのは、その間に新しい関係が生まれることです。\n\n前から見ればブレザー。\n横から見るとブルゾン。\n動くと背面のボリュームが現れる。\nボタンを閉じればフォーマル。\n開けばレイヤードがほどける。\n\n一着の内部で、用途や印象が時間差で変わる。\n\nEnclopediaでは、sacaiのハイブリッドを二着の接合ではなく、一着の中へ複数の時間と動作を設計することとして読みます。",
      },
      {
        index: "04",
        title:
          "消防服のクラスプは、装飾ではなく“接続する機能”の象徴である",
        text:
          "今季、黒いオーバーシャツ、黄色いジャンパー、ウォッシュ加工されたコットントレンチなど、異なる服を横断して繰り返されたのが金属製のクラスプです。\n\n消防服や作業服を連想させる留め具は、本来、素早く服を固定するための機能です。\n\nsacaiでは、それが複数のジャンルをつなぐ共通言語になります。\n\nシャツ、ニット、トレンチは別の服です。\nしかし同じクラスプが付くことで、三つの服が同じ設計思想から生まれたように見える。\n\nクラスプは、単なるワークディテールではありません。\n\n異なる服を“sacaiの服”として接続する句読点です。\n\nハイブリッドを象徴するのが異素材ではなく、接続するための小さな金具である点に、2027SSの原点回帰が表れています。",
      },
      {
        index: "05",
        title:
          "巨大なポーチポケットは、収納量ではなく身体の外側を設計する",
        text:
          "パンツに付けられた巨大な外向きのポーチポケットは、今季を象徴する造形です。\n\nポケットは本来、物を身体の近くに保持するためのものです。\n\nしかし、2027SSのポケットは身体から離れ、横へ張り出します。\n\n収納機能が、そのままシルエットへ変わる。\n\n物を入れる場所だったものが、身体の輪郭を作る場所になる。\n\nこれはsacaiが得意としてきた機能の転用です。\n\nポケットを無意味な装飾にするのではない。\nポケットらしい袋状の構造を残しながら、収納と造形の両方を担わせる。\n\nsacaiの機能性とは、実用性を優先することではなく、一つの機能へ複数の役割を与えることです。",
      },
      {
        index: "06",
        title:
          "Brooks Brothersは、正統性を壊すためではなく比較対象として必要だった",
        text:
          "2027SSの明確なメンズウェア表現として登場したのが、Brooks Brothersとの協業です。\n\nネイビーのブレザー。\n金ボタン。\nラペル。\nアメリカントラッド。\nリボンから吊られた羊のロゴ。\n\nBrooks Brothersは、男性服の正統性を示す非常に強い基準です。\n\nだからsacaiの操作が見えやすくなる。\n\nレイヤーを増やす。\nスリットを増やす。\nラペルを増やす。\n縫い目を増やす。\nブルゾンとダブルブレストを接続する。\n\nそれでもブレザーとしての品格は失われない。\n\nここが重要です。\n\n阿部千登勢は、トラッドを壊してストリート化しているのではありません。\n\n正統性を残したまま、服に含まれる選択肢を増やしています。\n\nBrooks Brothersは解体の犠牲ではなく、sacaiのハイブリッドがどこまで原型を尊重できるかを測る基準です。",
      },
      {
        index: "07",
        title:
          "“余分なもの”が増えるほど、服の正解は一つではなくなる",
        text:
          "Brooks Brothersのブレザーには、余分なレイヤー、余分なスリット、余分なラペル、余分な縫い目が加えられました。\n\n通常のデザインでは、余分なものは削られます。\n\nしかしsacaiでは、余分なものが新しい機能になります。\n\nラペルが二つあれば、どちらを前に見せるかが生まれる。\nスリットが増えれば、布の動きとレイヤードの見え方が変わる。\n縫い目が増えれば、服がどのように組み立てられたかを読むことができる。\n\n余分なものは過剰装飾ではありません。\n\n着方や見え方の選択肢です。\n\nsacaiが作るニュースタンダードとは、一つの完成された正解ではなく、複数の正解を内蔵した日常着なのです。",
      },
      {
        index: "08",
        title:
          "ネクタイは、男性を整える道具から自由な布へ戻される",
        text:
          "今季のネックウェアは、ネクタイでもスカーフでもありませんでした。\n\nストライプシルクは解体され、非常に長いボウのように垂れる。\n肩の上へ広げられる。\n細い房の束だけでネクタイの長さを作る。\nコサージュへ変形し、デニムやレザージャケットを飾る。\n\nネクタイは、男性のシャツとスーツを整えるための規則的な道具です。\n\n首から中央へ垂れ、左右を対称にし、社会的な正しさを示す。\n\n阿部千登勢は、その規則をほどきます。\n\n結ぶための細長い布を残しながら、首から解放する。\n\n肩へ置く。\n胸に咲かせる。\n房へ分解する。\n\nネクタイを女性的に変えたのではありません。\n男性服の規則から、布そのものを解放したのです。",
      },
      {
        index: "09",
        title:
          "ネクタイの解体は、フォーマルと装飾の境界を消している",
        text:
          "ネクタイには、フォーマルウェアという明確な役割があります。\n\n一方、ボウ、コサージュ、房飾りは装飾の領域にあります。\n\n2027SSでは、この二つが同じ布から作られます。\n\nつまりフォーマルな機能が、装飾的な機能へ連続している。\n\nsacaiのハイブリッドは、異なる素材を接続するだけではありません。\n\n一つの素材が持つ役割を変えることでも成立します。\n\nネクタイ用のストライプシルクだからこそ、ボウやコサージュになったときにも男性服の記憶が残る。\n\n元の意味を消さずに、別の意味を重ねる。\n\nこの二重性こそ、sacaiの原点です。",
      },
      {
        index: "10",
        title:
          "Soul II Soulは、プリントテーマではなくsacaiの編集方法を可視化する",
        text:
          "2027SSでは、英国の音楽集団Soul II Soulとの協業が行われました。\n\nボンバー、カーディガン、シャツ、ショーツ、スーツには、ロンドンのAfrica Centreで行われた日曜夜のセッションを記録した粒子の粗いアーカイブ写真が使われています。\n\nしかし重要なのは、写真プリントだけではありません。\n\nショーでは“Keep On Movin’”や“Back to Life”がリミックスされ、そこへStraussの“Blue Danube”が重ねられました。\n\n異なる時代、文化、リズムが一つの音へ編集される。\n\nこれはsacaiの服作りと同じです。\n\n既存の曲を完全に消さない。\n聞き覚えのあるフレーズを残しながら、別の音を差し込む。\n\nEnclopediaでは、阿部千登勢のハイブリッドをDJ的な編集として読みます。\n\n異なる服を縫い合わせるのではなく、元の服が持つリズムをサンプリングし、一着の中で再生順序を変えるのです。",
      },
      {
        index: "11",
        title:
          "“Keep On Movin’”は、変化し続けるsacaiの原点を言語化する",
        text:
          "Soul II Soulの“Keep On Movin’”は、ショーの音楽であると同時に、sacaiの姿勢を表す言葉にも見えます。\n\nsacaiはハイブリッドという方法を25年以上続けています。\n\n同じ方法を長く続ければ、やがて様式になります。\n様式は、簡単に反復やマンネリへ変わります。\n\nだから2027SSでは、ハイブリッドの見た目ではなく、その方法がなぜ必要なのかへ戻った。\n\n服を止めないため。\n日常着を完成したものにしないため。\n男性服を既存のルールへ固定しないため。\n\n“動き続ける”ことは、毎シーズンまったく違う服を作ることではありません。\n\n同じ服を、別の角度から問い続けることです。",
      },
      {
        index: "12",
        title:
          "“Back to Life”は、アーカイブを復刻するのではなく再び機能させること",
        text:
          "“Back to Life”という言葉も、sacaiの服作りに重なります。\n\n過去のボンバー。\n古典的なネイビーブレザー。\nトレンチコート。\nネクタイ。\nBirkenstockの定番サンダル。\nSoul II Soulのアーカイブ写真。\n\n2027SSに登場するものは、新しく発明された記号ばかりではありません。\n\nすでに存在し、意味が固まったものです。\n\n阿部千登勢は、それを復刻するのではなく、再び動かします。\n\nアーカイブを過去の完成品として保存するのではなく、現在の身体で使えるように機能を更新する。\n\nEnclopediaにとっても、これは重要な視点です。\n\nアーカイブ価値とは、古いことではありません。\n現在でも別の読み方と着方を発生させることです。",
      },
      {
        index: "13",
        title:
          "Birkenstockでは、定番同士を接続し“第三の定番”を作る",
        text:
          "Birkenstockとの協業では、Arizona、Boston、Madridといった象徴的モデルが接続されています。\n\nArizonaのストラップがBostonのクロッグ型アッパーへ重なる。\nMadridとArizonaのストラップが一足の中で融合する。\n\nここでもsacaiは、既存モデルの正体を消していません。\n\n見ればArizonaだと分かる。\nBostonだと分かる。\nMadridだと分かる。\n\nしかし、どれか一つだけではない。\n\nsacaiのハイブリッドは、二つの定番を混ぜて奇抜な靴を作ることではありません。\n\nそれぞれの定番性を保ったまま、まだ名前のない第三の定番を作ることです。",
      },
      {
        index: "14",
        title:
          "Dr. Wooのモチーフは、機能的なサンダルへ身体の記憶を重ねる",
        text:
          "一部のBirkenstockには、タトゥーアーティストDr. Wooのモチーフも加えられました。\n\nBirkenstockは、足の健康、構造、歩行、日常性と結びついた機能靴です。\n\n一方、タトゥーは身体へ残る私的な記号です。\n\nその二つが重なることで、サンダルは匿名的な道具から、身体の記憶を持つ表面へ変わる。\n\n機能性と装飾性を対立させるのではなく、機能する物に個人的な意味を重ねる。\n\nこれも2027SSが示すsacaiの原点です。\n\nハイブリッドとは、異なるカテゴリーの混合だけでなく、物へ複数の意味を持たせることです。",
      },
      {
        index: "15",
        title:
          "sacaiにおける機能は、“便利さ”ではなく変形する理由である",
        text:
          "sacaiは機能的な服だと説明されることがあります。\n\n確かにポケット、ジップ、ベルト、ドローコード、クラスプ、テクニカル素材が多く使われます。\n\nしかし、sacaiの機能性はアウトドアウェアのような効率性とは少し違います。\n\n機能は、服を変形させる理由です。\n\nクラスプがあるから開閉できる。\n開閉方法が変われば、前身頃の重なり方が変わる。\n\nスリットがあるから布が動く。\nポケットが膨らむから身体の輪郭が変わる。\nストラップが複数あるから、靴の見え方と固定方法が変わる。\n\n機能がシルエットを生み、シルエットが新しい着方を生む。\n\nEnclopediaでは、sacaiの機能を付加価値ではなく、造形が発生する原因として読みます。",
      },
      {
        index: "16",
        title:
          "sacaiは服を解体しているのではなく、服の選択肢を増やしている",
        text:
          "sacaiはしばしば“解体・再構築”と説明されます。\n\nしかし、その言葉だけでは川久保玲やMartin Margielaなどの脱構築と同じ枠に見えてしまいます。\n\nsacaiの操作は、服の制度を暴露することより、日常着の可能性を増やす方向へ向かいます。\n\nブレザーを壊してブレザーではなくするのではない。\n\nブレザーでありながら、ブルゾンでもあり、レイヤードでもあり、複数のラペルを持つ服にする。\n\nトレンチを未完成にするのではない。\n\nトレンチとして使えながら、ワークウェアの留め具と別の重なり方を持たせる。\n\nsacaiのハイブリッドは批評だけではありません。\n\n着る人に対して、昨日とは違う使い方を提示する実用的な提案です。",
      },
      {
        index: "17",
        title:
          "“Authentic language”とは、既存服を尊重しながら新しくすること",
        text:
          "阿部千登勢は今季、慣習的なルールを取り除きながら、真正な言語によって新しいものを作りたいと説明しました。\n\nここで言う真正性は、過去のsacaiらしさを再現することではありません。\n\n元の服への敬意です。\n\nBrooks Brothersを使うなら、ブレザーの品格を残す。\nBirkenstockを使うなら、それぞれのモデルの構造を残す。\nSoul II Soulを使うなら、アーカイブ写真と音楽文化の背景を残す。\n\nそのうえで、新しい関係を作る。\n\n原型を消して自分のデザインだけを見せるのではなく、元の服とsacaiの両方が読める状態にする。\n\nこれがsacaiのauthentic languageです。",
      },
      {
        index: "18",
        title:
          "2027SSは、“sacaiらしさ”を増やしたのではなく精度を上げた",
        text:
          "2027SSには、sacaiを象徴する要素が数多くあります。\n\nハイブリッド。\nレイヤード。\n異素材。\nコラボレーション。\nワークディテール。\nテーラリング。\nアーカイブ文化。\n\nしかし、これをsacaiらしさの総集編として見るべきではありません。\n\n今季は、要素を増やすのではなく、なぜそれらを使うのかを明確にしています。\n\nクラスプは接続のため。\nポケットは収納と輪郭のため。\nラペルは正統性と複数性のため。\nネクタイは規律と解放のため。\nコラボレーションは、本物の原型を借りるため。\n\nすべてのディテールに、ハイブリッドする理由がある。\n\n原点回帰とは、単純になることではなく、方法の精度を上げることです。",
      },
      {
        index: "19",
        title:
          "販売前の2027SSは、過去のsacaiアーカイブを読み直すための記事になる",
        text:
          "sacai 2027SSは、まだ一般販売前のシーズンです。\n\nそのため、この記事から今季商品をすぐ購入・レンタルすることはできません。\n\nしかし、新作を紹介するだけで終わる必要もありません。\n\n2027SSが問い直した原点から、過去のsacaiを見直すことができます。\n\nMA-1とコートのハイブリッド。\nニットとシャツの接続。\nトレンチの再構築。\n複数のラペルを持つテーラリング。\n巨大なポケット。\nワーク由来のクラスプやジップ。\nNike、Carhartt、The North Face、Levi’sなどとの協業。\n\nこれらはすべて、服の真正性を残しながら機能を増やすという同じ原点につながっています。\n\n2027SSの新しさは、過去作の意味を古くするのではなく、より明確にするのです。",
      },
      {
        index: "20",
        title:
          "sacai買取では、異素材切替の有無だけで判断してはいけない",
        text:
          "sacaiの買取では、異素材が使われている、コラボ商品である、という理由だけで価値を判断すると不十分です。\n\n見るべきなのは、ハイブリッドに理由があるかです。\n\n異なる服の原型がどれだけ明確に残っているか。\n前後や側面で別の機能が立ち上がるか。\nポケット、ジップ、ボタン、クラスプが構造へ関係しているか。\n着方によってシルエットが変化するか。\nコラボレーション先の真正性が残っているか。\nランウェイルックに近いか。\n\nEnclopediaでは、sacaiを単なる人気ブランドとしてではなく、服の構造と機能を更新してきたブランドとして確認します。",
      },
      {
        index: "21",
        title:
          "過去のメンズアーカイブは、2027SSによって再文脈化される",
        text:
          "2027SSがメンズウェアの原点を問い直したことで、過去のメンズアイテムも別の視点から評価できます。\n\nMA-1ドッキングジャケットは、異素材デザインだから重要なのではありません。\n\n軍用ブルゾンの短い丈、リブ、防風性と、コートの長さ、揺れ、都市性を一着へ共存させたから重要です。\n\nシャツとニットのハイブリッドも、見た目の切替だけではありません。\n\nシャツの清潔感とニットの伸縮性を同時に身体へ与えたからsacaiらしい。\n\n過去作の価値は、2027SSが示した“機能の再配置”という軸で、より正確に読み直すことができます。",
      },
      {
        index: "22",
        title:
          "レンタルで初めて分かるのは、ハイブリッドが身体上で切り替わる瞬間である",
        text:
          "sacaiの服は、平置き写真だけでは理解しきれません。\n\n前から見るとテーラードジャケット。\n歩くと背面のナイロンが膨らむ。\n腕を動かすとシャツやニットの別パーツが現れる。\nジップを開くとレイヤードが分離する。\nベルトやクラスプを留める位置で重心が変わる。\n\n一着の中に複数の服があることより、それらが動作によって切り替わることが重要です。\n\nEnclopediaのレンタルでは、sacaiのハイブリッドを情報として見るだけでなく、日常の動作の中で体験できます。",
      },
      {
        index: "23",
        title:
          "sacaiのメンズウェアとは、男性服へ“別の使い方”を残す服である",
        text:
          "では、sacaiのメンズウェアとは何か。\n\n男性を強く見せる服でもない。\n新しい男性性を提示する服でもない。\nただ異素材を組み合わせた服でもない。\n\n男性のワードローブに、別の使い方を残す服です。\n\nスーツはフォーマルだけではない。\nボンバーは軍用やストリートだけではない。\nトレンチは雨を防ぐだけではない。\nネクタイは社会的な規律だけではない。\nポケットは収納だけではない。\n\n既存の役割を消さず、その横にもう一つの役割を加える。\n\nだからsacaiの服は奇抜に見えても、日常へ戻ることができます。\n\nEnclopediaでは、この“日常へ戻れる実験性”こそ、sacaiメンズウェアの原点だと考えます。",
      },
    ],
    quote:
      "sacaiの原点とは、二つの服をつなぐことではない。一つの服へ、まだ存在していなかった別の使い方を加えることです。",
    perspectiveTitle:
      "Enclopediaは、sacai 2027SSを“ハイブリッドの原点回帰”ではなく“男性服の機能を再配分し、日常着へ複数の正解を残したコレクション”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "FUNCTION",
        text:
          "クラスプ、ポケット、ラペル、ネクタイ、ストラップを装飾ではなく、シルエットと着方を変える機能として読み解きます。",
      },
      {
        number: "02",
        title: "HYBRID",
        text:
          "sacaiのハイブリッドを、二着の接合ではなく、正統な原型へ新しい機能と時間を加える編集として整理します。",
      },
      {
        number: "03",
        title: "ARCHIVE VALUE",
        text:
          "2027SSは販売前ですが、過去のMA-1、トレンチ、ニット、シャツ、テーラリング、コラボレーション作品の価値を再文脈化します。",
      },
    ],
    experienceTitle:
      "sacai 2027SSを読んだら、過去のアーカイブで“機能するハイブリッド”を確かめる。",
    experienceBody:
      "sacai 2027SSは、まだ販売前のコレクションです。\n\nだから今、買取・レンタルへつなげるべき対象は2027SSそのものではありません。\n\n今季が明確にした原点を備える過去のsacaiです。\n\nMA-1とコートを接続したアウター。\nニットとシャツを一着へ組み込んだトップス。\nトレンチ、テーラリング、ワークウェアを再構築したジャケット。\n前後で異なる服の機能を持つアイテム。\nNike、The North Face、Carhartt、Levi’sなど、元ブランドの真正性を残しながらsacaiの構造へ変換した協業作品。\n\nEnclopediaでは、それらを“異素材切替だからsacaiらしい”という一括りでは見ません。\n\n元の服は何か。\nどの機能が残っているか。\n何が別の場所へ移されているか。\n着方によってどのようにシルエットが変わるか。\n\nその構造まで確認し、買取査定とレンタル体験へつなげます。",
    experienceItems: [
      "sacaiの品番・シーズン・メンズ／ウィメンズ区分を確認する",
      "MA-1、トレンチ、ブレザー、ニット、シャツなど元になった衣服を確認する",
      "異素材切替だけでなく、元の服の機能がどこに残っているかを見る",
      "ジップ、クラスプ、ボタン、ベルト、ドローコード、ポケットの配置を撮影する",
      "前面、背面、側面でシルエットや服のジャンルが変わるか確認する",
      "Brooks Brothers、Nike、Carhartt、The North Face、Levi’sなど協業先のタグを確認する",
      "コラボレーション先の原型やディテールがどれだけ残っているか確認する",
      "ランウェイルック、代表的なハイブリッド構造、希少サイズかを確認する",
      "付属パーツ、ベルト、フード、ライナー、タグ、ハンガーの有無を確認する",
      "毛羽立ち、ニットの伸び、ナイロンの傷、ジップ不良、パーツ欠損を確認する",
      "シーズン不明の場合もLINEで全体・タグ・ディテール写真を送る",
    ],
    archiveItemsTitle:
      "sacai 2027SSを入口に、過去のsacai買取・レンタルへ。",
    archiveItemsBody:
      "Enclopediaでは、sacaiを単なる異素材ドッキングのブランドとしてではなく、日常着の機能を分解し、別の使い方を追加してきたブランドとして見ています。2027SSで問い直されたメンズウェアの原点を手がかりに、過去のジャケット、コート、ニット、シャツ、コラボレーション作品を文脈込みで確認します。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "sacai買取ページへ",
        productPath: "/brand_buyback/sacai",
        productImage: "",
        text:
          "sacaiのジャケット、コート、ニット、シャツ、パンツ、バッグ、コラボレーションアイテムを、シーズン、構造、希少性、現在の需要まで含めて確認します。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "sacaiの価値をLINEで相談する",
        productPath: "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "品番やシーズンが分からない場合も、全体、品質表示、ブランドタグ、ジップやポケットなどのディテール写真から確認します。",
      },
      {
        label: "ARCHIVE FOCUS 04",
        title: "sacaiアーカイブを体験する",
        productPath: "/brand/SACAI（サカイ）/?number=63",
        productImage: "",
        text:
          "2027SSの販売を待つだけでなく、過去のMA-1、トレンチ、ニット、テーラリング、コラボレーションからsacaiの原点を体験できます。",
      },
    ],
    finalCta: {
      title:
        "sacai 2027SSを読んだら、過去の一着に残された“もう一つの機能”を確認する。",
      body:
        "sacai 2027SSは、まだ販売前のシーズンです。\n\nしかし、阿部千登勢が問い直した“sacaiのメンズウェアとは何か”という問いは、過去のsacaiを読み直す基準になります。\n\nMA-1、トレンチ、ブレザー、ニット、シャツ、ポケット、ジップ、コラボレーション。\n\nEnclopediaでは、それらがどのように接続され、どの機能が残され、どのような新しい着方へ変換されたのかまで確認します。\n\n所有しているsacaiの価値を知りたい方はLINE査定へ。\n実際に構造を身体で確かめたい方は、Enclopediaのsacaiレンタルをご覧ください。",
      buttonLabel: "sacaiをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;